import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSearchTerm, removeSearchTerm } from '@features/advancedSearch';
import { SearchBarBase, SearchBarBaseProps } from './SearchBarBase';
import { RootState } from '@app/types';

export interface SearchBarProps extends SearchBarBaseProps {
    disableHistory?: boolean;
}

export const SearchBar = ({
    onSubmit,
    disableHistory = false,
    suggestions,
    name = 'search',
    ...props
}: SearchBarProps) => {
    const dispatch = useDispatch();

    const globalHistory = useSelector((state: RootState) => {
        const historyData = state.searchHistory?.history;
        if (Array.isArray(historyData)) return [];
        return historyData?.[name] || [];
    });

    const handleSubmit = React.useCallback(
        (term: string) => {
            if (!disableHistory && term.trim()) {
                dispatch(addSearchTerm({ name, term }));
            }
            onSubmit?.(term);
        },
        [dispatch, disableHistory, name, onSubmit],
    );

    const handleRemoveSuggestion = React.useCallback(
        (term: string) => {
            dispatch(removeSearchTerm({ name, term }));
        },
        [dispatch, name],
    );

    const activeSuggestions =
        suggestions !== undefined
            ? suggestions
            : disableHistory
              ? []
              : globalHistory;

    return (
        <SearchBarBase
            {...props}
            name={name}
            suggestions={activeSuggestions}
            onSubmit={handleSubmit}
            onRemoveSuggestion={
                !disableHistory ? handleRemoveSuggestion : undefined
            }
        />
    );
};
